import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, MapPin, GraduationCap } from 'lucide-react';

const BeasiswaCard = ({ beasiswa }) => {
  // Format date to Indonesian format
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('id-ID', options);
  };

  // Format comma-separated values
  const formatCommaSeparated = (value) => {
    if (!value) return '';
    
    // If it's already an array, join with comma and space
    if (Array.isArray(value)) {
      return value.join(', ');
    }
    
    // If it's a string that contains commas, split and rejoin with comma and space
    if (typeof value === 'string' && value.includes(',')) {
      return value.split(',').map(item => item.trim()).join(', ');
    }
    
    // Otherwise, return as is
    return value;
  };

  // Calculate days remaining until deadline
  const calculateDaysRemaining = (deadlineString) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const deadline = new Date(deadlineString);
    deadline.setHours(0, 0, 0, 0);
    
    const diffTime = deadline - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    return diffDays;
  };

  const daysRemaining = calculateDaysRemaining(beasiswa.deadline);
  
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100 hover:shadow-lg transition-shadow">
      <Link to={`/beasiswa/${beasiswa.slug}`} className="block">
        <div className="aspect-[16/9] overflow-hidden bg-gray-100 relative">
          <img
            src={beasiswa.coverImage}
            alt={beasiswa.title}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.src = 'https://images.unsplash.com/photo-1546410531-bb4caa6b424d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1471&q=80';
            }}
          />
          {!isNaN(daysRemaining) && (
            daysRemaining > 0 ? (
              <div className="absolute top-3 right-3 bg-orange-500 text-white text-xs font-bold px-2 py-1 rounded">
                {daysRemaining} hari lagi
              </div>
            ) : (
              <div className="absolute top-3 right-3 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded">
                Ditutup
              </div>
            )
          )}
        </div>
      </Link>
      <div className="p-5">
        <Link to={`/beasiswa/${beasiswa.slug}`} className="block mb-2">
          <h3 className="text-lg font-semibold text-gray-900 line-clamp-2 hover:text-gold transition-colors">{beasiswa.title}</h3>
        </Link>
        
        <div className="flex flex-col gap-2 mb-4 text-sm">
          <div className="flex items-center text-gray-600">
            <Calendar className="h-4 w-4 mr-2 text-gold" />
            <span>Deadline: {beasiswa.deadline ? (new Date(beasiswa.deadline).toString() === 'Invalid Date' ? beasiswa.deadline : formatDate(beasiswa.deadline)) : '-'}</span>
          </div>
          <div className="flex items-center text-gray-600">
            <MapPin className="h-4 w-4 mr-2 text-gold" />
            <span>{formatCommaSeparated(beasiswa.country)}</span>
          </div>
          <div className="flex items-center text-gray-600">
            <GraduationCap className="h-4 w-4 mr-2 text-gold" />
            <span>{formatCommaSeparated(beasiswa.degree)}</span>
          </div>
        </div>
        
        <p className="text-gray-600 mb-4 line-clamp-3">{beasiswa.excerpt}</p>
        
        <Link
          to={`/beasiswa/${beasiswa.slug}`}
          className="inline-flex items-center justify-center bg-gold hover:bg-dark-navy text-white font-medium rounded-md px-3 py-1.5 text-sm transition-colors"
        >
          Lihat Detail
        </Link>
      </div>
    </div>
  );
};

export default BeasiswaCard;